export const environment = {
  production: true,
  apiUrls: {

    //Bandeja de Recepcion
    autorizaciones: 'https://backend-autorizaciones-dev.geamovil.com/autorizaciones', 
    bandeja: 'https://backend-autorizaciones-dev.geamovil.com',
    historialValidaciones: 'https://backend-autorizaciones-dev.geamovil.com/historial-validaciones',

    //Formulario
    formulario: 'https://backend-autorizaciones-dev.geamovil.com/formulario',
    farmacia: 'https://backend-autorizaciones-dev.geamovil.com/farmacia',
    prestador: 'https://backend-autorizaciones-dev.geamovil.com/provider',
    autorizacion: 'https://backend-autorizaciones-dev.geamovil.com/auth',
    afiliado: 'https://backend-autorizaciones-dev.geamovil.com/afiliado',

    //Manejo de Archivos
    file: 'https://backend-autorizaciones-dev.geamovil.com/file'
    
  }
};